<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body">
                        <div class="row g-3">
                            <div class="col-md-3">
                                <label for="type" class="form-label">Performance <b
                                        class="text-secondary">*</b></label>
                                <div class="input-group">
                                    <span class="input-group-text bg-transparent border-end-0">
                                        <i class='bx bxs-bar-chart-alt-2'></i></span>
                                    <ng-select class="form-control rcx-ng-select" 
                                        placeholder="Select Performance" [(ngModel)]="performanceId"
                                         [clearable]="false" [readonly]="isAssesmentCompleted">
                                        <ng-option *ngFor=" let performance of performances;"
                                            [value]="performance.id">{{performance.label}}</ng-option>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-md-9">
                                <label for="label" class="form-label">Remarks <b class="text-secondary">*</b></label>
                                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                                      class='bx bxs-purchase-tag'></i></span>
                                  <input type="text" class="form-control ps-1" id="label" placeholder="Enter label"
                                    autocomplete="off" [(ngModel)]="performanceRemarks"  [readonly]="isAssesmentCompleted"/>
                                </div>
                              </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>